export function getOrCreatePortalNode() {
    const id = "react-portal"
    const node = document.querySelector(`#${id}`)
    if (!node) {
        const div = document.createElement("div")
        div.setAttribute("id", id)
        document.body.appendChild(div)
        return div
    }
    return node
}
